import createErrorType from 'app/utils/createErrorType';
import { either } from 'fp-ts';

const TRUTHY = new RegExp('^(yes|on|true|1)$', 'i');
const FALSEY = new RegExp('^(no|off|false|0)$', 'i');

export class ParseError extends createErrorType('ParseError') {
}

export const parseBoolean = (x: string): either.Either<ParseError, boolean> => {
  const truthy = TRUTHY.test(x);
  const falsey = FALSEY.test(x);

  if (!truthy && !falsey) {
    return either.left(
      new ParseError(`Expected '${x}' to represent a true or false value`),
    );
  } else {
    return either.right(truthy);
  }
};
